<ng-template [ngIf]="selectedEvent">
  <picture class="relative block w-full h-96 bg-white -z-10 -mb-72">
    <img
      class="object-cover opacity-10 text-transparent"
      [ngSrc]="selectedEvent.ImageLarge"
      fill
      priority
      [alt]="selectedEvent.Title"
    />
  </picture>
  <div class="max-w-6xl mx-auto px-4 flex flex-col items-center">
    <div class="px-1 min-[1350px]:px-4 basis-2/3 max-w-4xl shrink-0 mb-12">
      <img
        class="object-cover rounded-3xl"
        width="1128"
        height="420"
        priority
        [ngSrc]="selectedEvent.ImageLarge"
        [alt]="selectedEvent.Title"
      />
    </div>
    <mobo-coupon-list
      [listTitle]="selectedEvent.Title || 'Evento não encontrada'"
      [campaigns]="selectedEvent.Campaigns"
      [showButton]="false"
    ></mobo-coupon-list>
  </div>
</ng-template>
